import { Pipe, PipeTransform } from '@angular/core';
import { GALLERY, NOTE, VIDEO } from '@careapp-group/core';

// Return the name of a mat-icon describing the content type.

@Pipe({
    name: 'contentTypeIcon',
    pure: true,
    standalone: false
})
export class ContentTypeIconPipe implements PipeTransform {
  public transform(type: string) {
    if (!type || type === '') {
      return '';
    }
    switch (type) {
      case 'CheckIn':
        return 'how_to_reg';
      case GALLERY:
        return 'insert_photo';
      case NOTE:
        return 'note';
      case VIDEO:
        return 'videocam';
      default:
        return '';
    }
  }
}
